module.exports = __webpack_public_path__ + "img/holidays_icon.42a286ec.svg";